export default class Component {
    constructor() {
        this.classes = []
        this.eventHandlers = []
    }

    init() {}

    afterInit() {
        this.classes.forEach(instance => {
            if (instance.afterInit()) {
                instance.afterInit()
            }
        })
    }

    addEventHandler({el, event, handler, passive = false}) {
        el.addEventListener(event, handler, {passive})

        this.eventHandlers.push({el, event, handler})
    }

    removeEventHandler(el, event, handler) {
        el.removeEventListener(event, handler)
    }

    pageLoaded() {
        this.classes.forEach(instance => {
            if (instance.pageLoaded) {
                instance.pageLoaded()
            }
        })
    }

    scroll() {
        this.classes.forEach(instance => {
            if (instance.scroll) {
                instance.scroll()
            }
        })
    }

    update() {
        this.classes.forEach(instance => {
            if (instance.update) {
                instance.update()
            }
        })
    }

    resize() {
        this.classes.forEach(instance => {
            if (instance.resize) {
                instance.resize()
            }
        })
    }

    destroy() {
        this.classes.forEach(instance => {
            if (instance.destroy) {
                instance.destroy()
            }
        })

        this.eventHandlers.forEach(eventHandler => {
            this.removeEventHandler(eventHandler.el, eventHandler.event, eventHandler.handler)
        })
    }
}